export default {"src":"/_next/static/media/flag-icon.85600e42.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};